"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shimLegacyToolbarOption = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var shimLegacyToolbarOption = function (option) {
    var hint = option.hint, hintSize = option.hintSize, value = option.value, onClick = option.onClick, onMouseEnter = option.onMouseEnter, onMouseLeave = option.onMouseLeave, icon = option.icon, isDisabled = option.isDisabled, selected = option.selected;
    var disabledValue = typeof isDisabled === "function" ? isDisabled() : isDisabled;
    return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { key: value, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, disabled: disabledValue, tooltip: hint ? { content: hint, size: hintSize } : undefined, selected: selected, isDestructive: value === "delete" }));
};
exports.shimLegacyToolbarOption = shimLegacyToolbarOption;
